export const MODAL_TYPE_SHARE_POST = 'share-post';
